<div class="doc-card-title">{{title}}</div>
<div class="doc-card">
  <div class="icon">
    <a *ngIf="viewable; else iconContent" (click)="viewDoc()" (keyup)="viewDoc()" aria-disabled="true"
      appTooltip="Visualiser le document"><ng-container *ngTemplateOutlet="iconContent"></ng-container></a>
  </div>
  <ng-template #iconContent>
    <mat-icon class="file-type" color="primary"><i [class]="iconClass"></i></mat-icon>
  </ng-template>
  <div class="content">
    <a *ngIf="viewable; else docContent" (click)="viewDoc()" (keyup)="viewDoc()" aria-disabled="true"
      appTooltip="Visualiser le document">
      <ng-container *ngTemplateOutlet="docContent"></ng-container>
    </a>
  </div>
  <ng-template #docContent>
    <div class="name text-truncate">{{ document.name }}</div>
    <div class="size text-truncate">{{ document.size | fileSize}}
    </div>
  </ng-template>
</div>
